(function() {
  // --- Helpers ---

  function parseZip() {
    var el = document.getElementById('popup-zip');
    if (!el) return null;
    var t = (el.textContent || el.innerText || '').trim();
    var zip = parseInt(t, 10);
    return isNaN(zip) ? null : zip;
  }

  function isCA(zip) {
    // CA ZIPs are roughly 90001–96199
    return zip >= 90000 && zip <= 96199;
  }

  function isTX(zip) {
    // TX ZIPs: 733xx, 750xx–799xx, 885xx (approx range)
    return (zip >= 73300 && zip <= 73399) ||
           (zip >= 75000 && zip <= 79999) ||
           (zip >= 88500 && zip <= 88599);
  }

  function isNorCal(zip) {
    return zip >= 94000 && zip <= 96162;
  }

  // Get cart total in cents from checkout button or FreeShippingBar
  function getCartTotalCents() {
    var btn = document.querySelector('.js-checkout-button');
    if (btn && btn.hasAttribute('data-cart-total')) {
      var val = parseInt(btn.getAttribute('data-cart-total'), 10);
      if (!isNaN(val)) return val;
    }

    var bar = document.querySelector('.FreeShippingBar[data-cart-total]');
    if (bar) {
      var v2 = parseInt(bar.getAttribute('data-cart-total'), 10);
      if (!isNaN(v2)) return v2;
    }

    return null;
  }

  /**
   * Business logic:
   * - NorCal (94000–96162) AND cart < $500 → freight $350
   * - cart ≥ $500 anywhere → freight $249
   * - else → no flat freight (return null)
   */
  function freightPriceForZip(totalCents) {
    var zip = parseZip();
    var THRESHOLD_CENTS = 50000; // $500

    if (!zip && zip !== 0) return null;

    if (isNorCal(zip) && totalCents < THRESHOLD_CENTS) {
      return 350;
    }

    if (totalCents >= THRESHOLD_CENTS) {
      return 249;
    }

    return null; // no flat freight case
  }

  function cartHasOnlyAccessories() {
    // requires cart item elements like: <div data-cart-item data-sku="accessories-123">
    var items = document.querySelectorAll('[data-cart-item]');
    if (!items.length) return false;

    for (var i = 0; i < items.length; i++) {
      var sku = items[i].getAttribute('data-sku') || '';
      if (!sku.toLowerCase().includes('accessories')) {
        return false; // found a non-accessory item
      }
    }
    return true;
  }

  // Universal money formatter (USD)
  function formatMoney(cents) {
    if (typeof cents === 'string') cents = parseInt(cents, 10);
    if (isNaN(cents)) cents = 0;

    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(cents / 100);
  }

  // --- 16FOOTOVER warning logic ---

  function update16FootOverWarning() {
    var warningEl = document.querySelector('.Cart__Warning--16FOOTOVER[data-has-16footover="true"]');
    if (!warningEl) return; // no 16FOOTOVER in cart

    var zip = parseZip();

    // Default: be safe and show the warning if we can't detect the state
    var showWarning = true;

    if (zip !== null) {
      if (isCA(zip) || isTX(zip)) {
        showWarning = false;
      }
    }

    warningEl.style.display = showWarning ? 'block' : 'none';
  }
  window.update16FootOverWarning = update16FootOverWarning;

  // --- Freight price bar logic ---

  function updateFreightPriceForRegion() {
    var totalCents = getCartTotalCents();
    if (totalCents === null) return;

    var freight = freightPriceForZip(totalCents);

    // If no flat freight currently applies (freight === null),
    // we still want the bar to talk about the $249 "unlock" price.
    var displayPrice = freight !== null ? freight : 249;

    document.querySelectorAll('.FreeShippingBar .js-freight-price').forEach(function(span) {
      span.textContent = '$' + displayPrice;
    });
  }
  window.updateFreightPriceForRegion = updateFreightPriceForRegion;

  // --- Checkout button total logic ---

  function updateCheckoutButtonTotal() {
    var btn = document.querySelector('.js-checkout-button');
    if (!btn) return;

    var totalCents = parseInt(btn.getAttribute('data-cart-total'), 10);
    if (isNaN(totalCents)) return;

    var totalSpan = document.querySelector('.js-checkout-total');
    if (!totalSpan) return;

    // 1) Accessories-only? -> do NOT add freight
    if (cartHasOnlyAccessories()) {
      totalSpan.textContent = formatMoney(totalCents);
      return;
    }

    // 2) 16FOOTOVER + non-CA/TX (warning visible) -> do NOT add freight, they must call
    var warningEl = document.querySelector('.Cart__Warning--16FOOTOVER[data-has-16footover="true"]');
    if (warningEl && warningEl.style.display === 'block') {
      totalSpan.textContent = formatMoney(totalCents);
      return;
    }

// 3) Always show the true cart subtotal on the checkout button.
    //    Flat freight ($249 / $350 NorCal) is applied at checkout by the
    //    shipping app after the address step, and is already communicated by
    //    the FreeShippingBar message above. Adding it here made the button
    //    disagree with the real checkout total (and it omitted tax anyway).
    totalSpan.textContent = formatMoney(totalCents);
  }

  window.updateCheckoutButtonTotal = updateCheckoutButtonTotal;

  // --- Initial run on page load ---

  document.addEventListener('DOMContentLoaded', function() {
    update16FootOverWarning();
    updateFreightPriceForRegion();
    updateCheckoutButtonTotal();
  });

  // Optional: if you fire a custom event after cart re-render
  document.addEventListener('cart:refresh', function() {
    update16FootOverWarning();
    updateFreightPriceForRegion();
    updateCheckoutButtonTotal();
  });

})();
